(function(){
'use strict';

angular.module('classy').constant('LOCAL_HOST_URL', 'http://localhost.classy-test.org:4000');
angular.module('classy').constant('CLASSY_DOMAINS', ['classy.org', 'classy-test.org', 'localhost', 'classy-lab.org']);
angular.module('classy').constant('CLASSY_GIVE_DOMAIN', 'https://give.classy.org');
})();